<template>
  <table class="tw-mt-16 variations fffa-results-table">
    <thead>
    <tr>
      <th colspan="9">
        {{ pool && pool.label ? pool.label : 'Poule' }}
      </th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="match in matches">
      <td>{{ formatDateTime(match.date) }}</td>
      <td><a :href="match.sheet" target="_blank" v-if="match.sheet">FDM</a></td>
      <td class="tw-border-dashed">
        <a :href="match.team_a.stats" target="_blank" v-if="match.team_a.stats">Stats</a>
      </td>
      <td class="tw-border-dashed">
        {{ match.team_a.name }}
        <span v-if="match.team_a.general_forfeit" class="tw-block tw-text-sm tw-text-red">Forfait général</span>
      </td>
      <td>{{ match.team_a.score }}</td>
      <td>VS</td>
      <td class="tw-border-dashed">
        {{ match.team_b.score }}
      </td>
      <td class="tw-border-dashed">
        {{ match.team_b.name }}
        <span v-if="match.team_b.general_forfeit" class="tw-block tw-text-sm tw-text-red">Forfait général</span>
      </td>
      <td>
        <a :href="match.team_b.stats" target="_blank" v-if="match.team_b.stats">Stats</a>
      </td>
    </tr>
    <tr v-if="!matches.length && !loading">
      <td colspan="9">
        Aucun match trouvé
      </td>
    </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'matches-table',
  props: {
    loading: Boolean,
    matches: {
      type: Array,
      default: () => [],
    },
    pool: {
      type: Object,
      default: null,
    },
  },
  methods: {
    /**
     * @param {Date} date
     * @return {string}
     */
    formatDateTime(date) {
      return date.toLocaleDateString('fr') + ' ' + date.toLocaleTimeString('fr', {
        hour: '2-digit',
        minute: '2-digit',
      });
    },
  },
};
</script>
